/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */

import React from 'react'
import s from './Step.module.css'
import { Video } from '../../../Video'

export function Step({ video, step, title, desc }) {
  return (
    <div className={s.root}>
      <Video className={s.video} src={video} />

      <div className={s.step}>{step}</div>
      <div className={s.title}>{title}</div>
      <div className={s.desc}>{desc}</div>
    </div>
  )
}
